export class Config {
}
Config.calibrationTool_colorHex = 0xff0000;
Config.calibrationTool_maxCircleRadius = 100;
Config.calib_point_scale = 1;
Config.calib_ring_colorHex = 0xb4ebff;
Config.calib_ring_opacity = 0.5;
Config.calib_mastertab_color = 0xff0000;
Config.calib_mastertab_radius = 3;
Config.calib_cone_height = 10;
Config.calib_cone_radius = 2;
Config.calib_cone_color = 0xffff00;
Config.reference_colorHex = 0x00ffff;
Config.reference_colorCss = "#00ffff";
Config.reference_colorCssAlpha = "rgba(0, 255, 255, 0.6)";
Config.moving_colorHex = 0x00ff00;
Config.moving_colorCss = "#00ff00";
Config.moving_colorCssAlpha = "rgba(0, 255, 0, 0.6)";
Config.moving_reference_fontColor = "#000000";
Config.apex_colorHex = 0xff0000;
Config.apex_colorCss = "#ff0000";
Config.apex_colorCssAlpha = "rgba(255, 0, 0, 0.6)";
Config.apex_fontColor = "#ffffff";
Config.apex_line_gap_size = 2;
Config.apex_dash_size = 1;
Config.apex_line_width = 1.5;
Config.apex_line_color = 0xffff00;
Config.thirdLine_colorHex = 0xffff00;
Config.osteotomy_colorHex = 0xff0000;
Config.osteotomy_colorCss = "#ff0000";
Config.osteotomy_colorCssAlpha = "rgba(255, 0, 0, 0.6)";
Config.osteotomy_fontColor = "#ffffff";
//# sourceMappingURL=Config.js.map